import { PrintShopMetaSetting } from "../../../../../api/front/system-config/api-meta-shop"
import { Select } from "../../../../ui/select/select"
import { PrintLabeledUI } from "../../../sift/print-create-order/component/print-labeled-ui"
import { Checkbox } from '../../../../ui/input/checkbox';
import './print-setting-dialog.scss';
import { Button } from "../../../../ui/button/button";
import { useCallback, useState } from "react";
import { useAppDispatch } from "../../../../../app/hooks";
import { dialogActions } from "../../../../dialog/slice/dialog-slice";
import { PRINT_LAYOUT_POS } from "../../../../../models/sift/select/layout-pos";

type Props = {
  request: PrintShopMetaSetting,
  setRequest: (v: PrintShopMetaSetting) => void,
}

export const PrintSetting = (props: Props) => {
  const {
    request,
    setRequest,
  } = props;
  const dispatch = useAppDispatch();
  const [layoutPos, setLayoutPos] = useState(request.layoutPos);
  const [layoutMargin, setLayoutMargin] = useState(request.layoutMargin);
  const [toneCorrection, setToneCorrection] = useState(request.toneCorrection);
  const [autoTrimming, setAutoTrimming] = useState(request.autoTrimming);
  const [backPrint, setBackPrint] = useState(request.backPrint);
  const handlerClickOk = useCallback(() => {
    setRequest({
      layoutPos,
      layoutMargin,
      toneCorrection,
      autoTrimming,
      backPrint,
    });
    dispatch(dialogActions.pop());
  }, [
    layoutPos,
    layoutMargin,
    toneCorrection,
    autoTrimming,
    backPrint,
    setRequest,
    dispatch
  ]);
  const handlerClickCancel = useCallback(() => {
    dispatch(dialogActions.pop());
  }, [dispatch]);
  const handlerChangeLayoutInit = useCallback((v: 1 | 2 | 3) => {
    if (layoutPos === 1 && v !== 1) {
      dispatch(dialogActions.pushMessage({
        title: '確認',
        message: [
          '画像の初期配置方法が「内接」か「ピクセル等倍」の場合は、',
          '初期配置時に余白が出る可能性があります。',
          'そのため、「レイアウト時の余白」の許可設定が強制的にONになりますが、',
          'よろしいですか？',
        ],
        buttons: [
          { label: 'キャンセル', callback: () => dispatch(dialogActions.pop())},
          { label: 'OK', callback: () => {
            dispatch(dialogActions.pop());
            setLayoutPos(v);
            setLayoutMargin(true);
          }},
        ]
      }))
    } else {
      setLayoutPos(v);
    }

  }, [
    layoutPos,
    dispatch,
  ]);
  return (
    <div className="matomete_print_setting">
      <div className="matomete_print_setting__body">
        <PrintLabeledUI label="画像の初期配置方法">
          <Select
            list={PRINT_LAYOUT_POS.map((v) => ({...v, value: `${v.value}`}))}
            value={`${layoutPos}`}
            onChange={(e) => handlerChangeLayoutInit((Number(e.target.value) || 1) as 1 | 2 | 3)}
          />
        </PrintLabeledUI>
        <PrintLabeledUI label="レイアウト時の余白">
          <Checkbox
            label="余白を許可する"
            checked={layoutMargin}
            onClick={() => setLayoutMargin(!layoutMargin)}
            disabled={layoutPos !== 1}
          />
        </PrintLabeledUI>
        <PrintLabeledUI label="色補正の初期値">
          <Checkbox
            label="色補正する"
            checked={toneCorrection}
            onClick={() => setToneCorrection(!toneCorrection)}
          />
        </PrintLabeledUI>
        <PrintLabeledUI label="トリミングの初期値">
          <Checkbox
            label="トリミングを任せる"
            checked={autoTrimming}
            onClick={() => setAutoTrimming(!autoTrimming)}
          />
        </PrintLabeledUI>
        <PrintLabeledUI label="裏印字をする">
          <Checkbox
            label="裏印字をする"
            checked={backPrint}
            onClick={() => setBackPrint(!backPrint)}
          />
        </PrintLabeledUI>
      </div>
      <div className="matomete_print_setting__footer">
        <Button label="キャンセル" onClick={handlerClickCancel} />
        <Button label="OK" onClick={handlerClickOk} />
      </div>
    </div>
  )
}